/* Elin Perfumes — promo banner slots.
 *
 * The section reserves card positions; banners are a pool that qualifies per
 * collection. Assignment happens here rather than in Liquid because a theme
 * block cannot see how many banners before it qualified — filling from Liquid
 * would leave a gap wherever an earlier banner was skipped.
 *
 * Banners render hidden and are revealed once they hold a slot, so a banner
 * with nowhere to go never flashes on screen.
 */
(() => {
  const config = document.querySelector('[data-elin-slots]');
  const grid = document.querySelector('ul.product-grid');
  if (!config || !grid) return;

  let slots;
  try {
    /* Any run of non-digits separates positions, not just a comma. This value is a
       section setting, so Translate & Adapt exposes it for translation -- and the
       first Spanish auto-translate turned "5,11,20" into "5/11/20". Split on commas
       that became one token, parseInt read its leading 5, and two of the three
       banners were silently removed from every Spanish collection page. */
    slots = String(JSON.parse(config.textContent) || '')
      .split(/[^0-9]+/)
      .map((n) => parseInt(n.trim(), 10))
      .filter((n) => Number.isFinite(n) && n > 0);
  } catch {
    return;
  }

  const banners = [...grid.querySelectorAll('.elin-promo-item')];

  banners.forEach((banner, i) => {
    const slot = slots[i];
    if (slot === undefined) {
      banner.remove();
      return;
    }
    banner.style.order = String(slot);
    banner.hidden = false;
  });
})();
